import React from 'react';
import { Link } from 'react-router-dom';
import './campaigns.css';

const PromoBanner = ({ campaign }) => {
  if (!campaign) return null;

  const link = campaign.linkUrl;
  const content = (
    <>
      {campaign.imageUrl && (
        <img src={campaign.imageUrl} alt={campaign.title} loading="lazy" />
      )}
      <div className="campaign-banner__content">
        <h3 className="campaign-banner__title">{campaign.title}</h3>
        {(campaign.subtitle || campaign.description) && (
          <p className="campaign-banner__subtitle">
            {campaign.subtitle || campaign.description}
          </p>
        )}
        {campaign.couponCode && (
          <span className="campaign-coupon">Code: {campaign.couponCode}</span>
        )}
      </div>
    </>
  );

  if (link) {
    if (/^https?:\/\//i.test(link)) {
      return (
        <a href={link} className="campaign-banner" target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      );
    }
    const to = link.startsWith('/') ? link : `/${link}`;
    return (
      <Link to={to} className="campaign-banner">
        {content}
      </Link>
    );
  }

  return <div className="campaign-banner">{content}</div>;
};

export default PromoBanner;
